import React, { useState, useEffect } from "react";
import { Row, Col, Typography, Spin } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import "./LoginPage.css";
import LoadingSpinner from "./LoadingSpinner";
import { URL } from "../config";

const { Title } = Typography;


const LoginPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false); 
  const [buttonLoading, setButtonLoading] = useState(false);
  const [loginText, setLoginText] = useState("Login");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showEye, setShowEye] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePasswordChange = (e) => {
    const val = e.target.value;
    setPassword(val);
    setShowEye(val.length > 0);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password) {
      toast.error("Please enter username & password");
      return;
    }

    try {
      setButtonLoading(true);
      setLoginText("Please wait...");
      setLoading(true);

     const response = await axios.post(`${URL}/login`, {
  userName: username.trim(),
  password: password.trim(),
});


      const { token, user } = response.data;

    
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      toast.success("Login successful");

      setLoginText("Login Successfully");

      setTimeout(() => {
        setLoading(false);
        navigate("/dashboard");
      }, 1000);
    } catch (error) {
      setLoading(false);
      setButtonLoading(false);
      setLoginText("Login");

      if (error.response?.status === 401) {
        toast.error("Invalid username or password");
      } else {
        toast.error("Server error, try again");
      }
    } finally {
      setTimeout(() => {
        setButtonLoading(false);
        setLoginText("Login");
      }, 1500);
    }
  };

  return (
    <>
   
      {loading && <LoadingSpinner />}

      <Row
        style={{
          minHeight: "100vh",
          backgroundColor: "#d5d4d4ff",
          padding: isMobile ? "0 10px" : "40px 120px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      
        {!isMobile && (
          <Col
            xs={0}
            md={12}
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-start",
              padding: "40px",
              background:
                "linear-gradient(135deg, #286d84 0%, #388ca2 60%, #174253 100%)",
              borderRadius: "16px 0 0 16px",
              minHeight: "500px",
              overflow: "hidden",
              color: "#fff",
            }}
          >
            <img
              src="/images/cctv6.png"
              alt="CCTV"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "590px",
                height: "500px",
                zIndex: 1,
              }}
            />
            <div style={{ zIndex: 2 }}>
              <h3 style={{ fontSize: "19px", margin: 0, fontWeight: "600" }}>
                Protect What Matters Most:
              </h3>
              <p style={{ fontSize: "16px", marginTop: "8px" }}>
                Premium CCTV Solutions for Home & Business.
              </p>
            </div>
          </Col>
        )}

        <Col
          xs={24}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: isMobile ? "transparent" : "#ffffff",
            borderRadius: isMobile ? "16px" : "0 16px 16px 0",
            padding: isMobile ? "30px 10px" : "40px 30px",
            position: "relative",
            zIndex: 3,
            minHeight: "500px",
          }}
        >
          <div className="login-box">
            <Title
              level={2}
              style={{
                color: isMobile ? "#388ca2" : "#000",
                marginBottom: "30px",
                textAlign: "center",
              }}
            >
              Login
            </Title>

            <form onSubmit={handleSubmit}>
              <div className="field">
                <UserOutlined className="field-icon" />
                <input
                  type="text"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
                <div className={`underline ${username ? "active" : ""}`} />
              </div>

              <div className="field">
                <LockOutlined className="field-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={handlePasswordChange}
                  required
                />
                {showEye && (
                  <span
                    className="eye-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <EyeInvisibleOutlined />
                    ) : (
                      <EyeOutlined />
                    )}
                  </span>
                )}
                <div className={`underline ${password ? "active" : ""}`} />
              </div>

              <button
                type="submit"
                className="login-btn"
                disabled={buttonLoading}
              >
                {buttonLoading ? (
                  <Spin size="small" className="custom-white-spin" />
                ) : (
                  loginText
                )}
              </button>
            </form>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default LoginPage;
